export const Alumnos = {
	LISTAR: 'alumnos',
	OBTENER_POR_NUMERO_CONTROL: (numeroControl) => `alumnos/numeroControl/${numeroControl}`,
	ENVIAR_CORREO: (numeroControl) => `alumnos/enviarCorreo/${numeroControl}`,
	VERIFICAR_CORREO: (numeroControl) => `alumnos/verificarCodigoCorreo/${numeroControl}`,
	ACTUALIZAR_INFORMACION: (numeroControl) => `alumnos/actualizarInformacionAlumno/${numeroControl}`,
	ACTUALIZAR_STEP_ACTIVE: (numeroControl) => `alumnos/actualizarStepActive/${numeroControl}`,
};

export const OpcionesTitulacion = {
	LISTAR: 'opcionesTitulacion'
};


export const Planes = {
	LISTAR: 'planes'
};

export const AlumnosTramiteDocumentos = {
	OBTENER_POR_NUMERO_CONTROL: (numeroControl) => `alumnosTramiteDocumentos/numeroControl/${numeroControl}`,
	SUBIR_DOCUMENTO: (numeroControl) => `alumnosTramiteDocumentos/subirDocumento/${numeroControl}`,
};
